import WorldOfStamps from "./WorldOfStamps";

export default WorldOfStamps;
